module.exports = __webpack_public_path__ + "be6379111ab8866c20c123b85af97d42.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/norway.png
 ** module id = 668
 ** module chunks = 0
 **/